import styled from 'styled-components';
import breakpoint from 'theme/breakpoint';

const Infobox = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: ${props => props.theme.paddingS};
  margin-bottom: ${props => props.theme.paddingS};
  background-color: ${props => props.theme.infoBackground};
  
  img {
    margin: 0 ${props => props.theme.paddingM};
    margin-bottom: ${props => props.theme.paddingS};
  }
  
  ${breakpoint.up('s')`
    flex-wrap: nowrap;
    justify-content: flex-start;
    
    img {
      margin-bottom: 0;
    }
  `}
`

export default Infobox;
